// Generated by run_apcc_mme_daily.py. Do not edit by hand.
export const apccCatalog = {
  "products": {
    "apcc.forecast.t2m.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "t2m",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t2m/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.prec.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "prec",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/prec/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.sst.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "sst",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/sst/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.slp.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "slp",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/slp/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.t850.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "t850",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/t850/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.z500.3m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "z500",
      "lead": "3m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/deterministic/monthly/z500/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.prec.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "prec",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/prec/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.t2m.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "t2m",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t2m/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.sst.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "sst",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/sst/rmi/voronoi/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.slp.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "slp",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/slp/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.t850.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "t850",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/t850/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.z500.3m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "z500",
      "lead": "3m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/3m/probabilistic/monthly/z500/indo/gridded/2026-10-01.fgb"
        }
      ]
    },
    "apcc.forecast.prec.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "prec",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/prec/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.t2m.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "t2m",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t2m/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.sst.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "sst",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/sst/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.slp.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "slp",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/slp/indo/gridded/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.t850.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "t850",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/t850/indo/gridded/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.z500.6m.deterministic.monthly": {
      "dataType": "forecast",
      "variable": "z500",
      "lead": "6m",
      "model": "deterministic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/deterministic/monthly/z500/indo/gridded/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.prec.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "prec",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/prec/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.t2m.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "t2m",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t2m/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.sst.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "sst",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2026-08-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2026-08-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2026-09-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2026-09-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2026-10-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2026-10-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2026-11-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2026-11-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2026-12-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2026-12-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/contour/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/gridded/2027-01-01.fgb"
        },
        {
          "scope": "palau",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/palau/voronoi/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/contour/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/gridded/2027-01-01.fgb"
        },
        {
          "scope": "rmi",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/sst/rmi/voronoi/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.slp.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "slp",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/slp/indo/gridded/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.t850.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "t850",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/t850/indo/gridded/2027-01-01.fgb"
        }
      ]
    },
    "apcc.forecast.z500.6m.probabilistic.monthly": {
      "dataType": "forecast",
      "variable": "z500",
      "lead": "6m",
      "model": "probabilistic",
      "issue": "202608",
      "records": [
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-08-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-08-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-09-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-09-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-10-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-10-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-11-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-11-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2026-12-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2026-12-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "contour",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/contour/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "gridded",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2027-01-01.fgb"
        },
        {
          "scope": "indo",
          "mode": "voronoi",
          "valid": "2027-01-01",
          "path": "/jsonFiles/apcc/forecast/6m/probabilistic/monthly/z500/indo/gridded/2027-01-01.fgb"
        }
      ]
    }
  },
  "schemaVersion": 1,
  "updated": "2026-08-19T02:40:23Z",
  "resolution": "1.0\u00b0",
  "attribution": "The authors acknowledge the APCC MME Producing Centers for making their hindcast/forecast data available for analysis, the APEC Climate Center for collecting and archiving the data, as well as for producing APCC MME predictions."
};
export default apccCatalog;
